module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app__footer"
  }, [_c('div', {
    staticClass: "icon-group"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/chattahoocheeriverkeeper/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook icon-group__facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/CRKeeper",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter icon-group__twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/crkeeper/#",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram icon-group__instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vimeo.com/crkeeper",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-vimeo icon-group__vimeo"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/UCRiverkeeperVideos",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play icon-group__youtube"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-info"
  }, [_c('div', {
    staticClass: "footer-info__text"
  }, [_vm._v("\n      Copyright\n      "), _c('i', {
    staticClass: "fa fa-copyright",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      2017 Chattahoochee Riverkeeper | All Rights Reserved\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "footer-info__text"
  }, [_vm._v("\n      Phone (404) 352-9828 |\n      "), _c('a', {
    staticClass: "footer-info__text--underline footer-info__text--active",
    attrs: {
      "href": "mailto:info@chattahoochee.org"
    }
  }, [_vm._v("info@chattahoochee.org")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d19bdcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-footer.vue
// module id = 441
// module chunks = 1